<script>
  export let iconClass = '';
</script>
<svg width="20" height="16" viewBox="0 0 20 16" fill="currentColor" class={iconClass} xmlns="http://www.w3.org/2000/svg">
  <path d="M8.2 9.75H1M6.4 6.25H1M4.6 2.75H1M10 13.25H1M16.3 15V1M16.3 15L19 12.375M16.3 15L13.6 12.375M16.3 1L19 3.625M16.3 1L13.6 3.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>